/**
 * Livelli utente della piattaforma.
 *
 *   0  admin globale     — Gruppo YEC: vede e gestisce tutti i condomini
 *   1  admin condominio  — amministratore del proprio condominio
 *   2  condomino         — prenota e gestisce le proprie prenotazioni
 *
 * L'approvazione di un nuovo iscritto non passa dal livello ma dal flag
 * `abilitato`: si nasce condomino (livello 2) e non abilitati. Chi
 * amministra, a qualunque titolo, e' abilitato per definizione.
 */
import { optValue } from './format';

export const ADMIN_GLOBALE = 0;
export const ADMIN_CONDOMINIO = 1;
export const CONDOMINO = 2;

export const LIVELLI = [
    { value: ADMIN_GLOBALE, label: 'Amministratore globale' },
    { value: ADMIN_CONDOMINIO, label: 'Amministratore condominio' },
    { value: CONDOMINO, label: 'Condomino' }
];

/** Livello dell'utente, che arrivi dalla login o da un record dell'API. */
export function livelloDi(user) {
    if (!user) return null;
    const l = parseInt(optValue(user.level), 10);
    return isNaN(l) ? null : l;
}

export function etichettaLivello(level) {
    const l = LIVELLI.find(v => v.value === parseInt(optValue(level), 10));
    return l ? l.label : '—';
}

/** Etichetta breve, per header e badge. */
export function etichettaBreve(level) {
    const l = parseInt(optValue(level), 10);
    if (l === ADMIN_GLOBALE) return 'Admin globale';
    if (l === ADMIN_CONDOMINIO) return 'Amministratore';
    return 'Condomino';
}

/** Amministratore, globale o di condominio: ha accesso all'area admin. */
export function isAdmin(user) {
    const l = livelloDi(user);
    return l !== null && l <= ADMIN_CONDOMINIO;
}

export function isAdminGlobale(user) {
    return livelloDi(user) === ADMIN_GLOBALE;
}

/**
 * Solo il condomino ha bisogno del via libera dell'amministratore:
 * chi amministra non passa dall'approvazione.
 */
export function richiedeApprovazione(level) {
    const l = parseInt(optValue(level), 10);
    return isNaN(l) || l > ADMIN_CONDOMINIO;
}

/**
 * Livelli che l'utente può assegnare a un altro account.
 * Un admin di condominio nomina co-amministratori del proprio condominio,
 * ma non crea admin globali.
 */
export function livelliAssegnabili(user) {
    return isAdminGlobale(user)
        ? LIVELLI
        : LIVELLI.filter(l => l.value !== ADMIN_GLOBALE);
}
